import type { IReportAggregation } from './ReportAggregation.interface';

export default class ReportAggregation implements IReportAggregation {
  term: string;
  type: string;

  static build = (data: IReportAggregation) => new ReportAggregation(data);
  static blank = () => new ReportAggregation();

  /**
   * Constructor
   * @param {IReportAggregation} data
   */
  constructor(data?: IReportAggregation) {
    this.term = data?.term || undefined;
    this.type = data?.type || undefined;
  }
}
